import React from 'react';

const Nosotros = () => {
	return (
		<section className='nosotros' id='about'>
			<div className='nosotros__container'>
				<h2 className='nosotros__title'>Sobre Nosotros</h2>

				<div className='nosotros__contenido'>
					<div>
						<p className='nosotros__texto'>
							Somos una empresa Colombiana que fabrica mesas de corte, cambiando la forma en que las pequeñas y medianas
							empresas piensan sobre el metal, analizamos los problemas mas comunes con un enfoque en la rapidez y corte
							confiable para entregar valor a nuestros clientes.
						</p>
						<p className='nosotros__texto'>
							En CARSO CNC nos dedicamos a solucionar los problemas de una buena fabricación, mas rápida y con gran
							calidad de corte nos esforzamos cada día por ofrecer el mejor precio en el mercado para cualquier clase de
							usuario que busca automatizar el proceso que requiere su taller.
						</p>
					</div>
					<div className='nosotros__contenido-imagen'>
						<img src='./img/temporal.svg' alt='imagen nosotros' height='200' />
					</div>
				</div>
			</div>
		</section>
	);
};

export default Nosotros;
